import React from 'react';
// import PointLoginLogo from './../../resources/point_club_logo.jpg'
export const Link = (props) => {
    return(
        <a onClick={props.onClick} style={props.style} className={props.className} href={props.href} target={props.target} rel={props.rel}>{props.linkTitle}</a> 
    );
}